




import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";



@Component
export default class ButtonInspectResult extends Vue {

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  created() {}
  goStatusResult() {
    this.$router.push({ name: "statusresult" });
  }
}
